<!-- Notifications -->
<li class="nav-item">
  <a class="search-toggle iq-waves-effect cp"  (click)="openDrop()">
    <i class="fa fa-bell-o"></i>
    <span class="badgedot dots" *ngIf="unReadCount > 0"><h2 class="ffhfhfhf">{{unReadCount}}</h2></span>
  </a>
  <div class="DropDv" *ngIf="isOpen">
    <div class="iq-card shadow-none m-0">
      <div class="iq-card-body p-0">
        <div class="bg-primary p-3">
          <h5 class="mb-0 text-white">
            All Notifications
            <!-- <small class="badge  badge-light float-right pt-1">{{ notificaitons.length }}</small> -->
          </h5>
        </div>
        <div class="bodyDv">
        <p class="fffffDv"  *ngIf="!notificaitons.length">No Notifications Found !</p>
        <ng-container *ngIf="notificaitons">
          <a class="iq-sub-card" *ngFor="let item of notificaitons">
            <div class="media align-items-center InfoDv" (click)="goToDetail(item)">
              <div class="" *ngIf="item && item.data">
                <img class="avatar-40 rounded" *ngIf="item.data.photoUrl" [src]="item.data.photoUrl" alt="">
                <img class="avatar-40 rounded" *ngIf="!item.data.photoUrl" src="../../../assets/images_v2/bg-03.jpg" alt="">
              </div>
              <div class="media-body ml-3" *ngIf="item && item.data">
                <h6 class="mb-0 head01">{{ item.data.title  }}</h6>
                <p class="mb-0 head02">{{ item.data.body }}</p>
                <small class="float-right font-size-12">{{ item.createdOn | date }}</small>
              </div>
            </div>
          </a>
        </ng-container>
        </div>
        <ul class="paginationDv" (click)="seeMore()" *ngIf="showSeeMore && notificaitons.length > 4">
          <li><p>See More</p></li>
        </ul>
       </div>
    </div>
  </div>
</li>
